import { accountService } from "@/services/AccountService";
import router from '@/router'
import { JWTHelper } from "@/helpers/JWTHelper";
import { resetCrisp } from "@/helpers/CrispHelper";
import { markAppReloading } from "@/helpers/appReload";

const state = {
    isLoggedIn: JWTHelper.isLoggedIn(),
    user: null,
    isLoadingRequest: false,
    loginMessage: '',
    isSuperUser: false,
    abilities: null,
    firstAllowedPage: null
};

const actions = {
    login({ dispatch, commit }, { username, password, orgId }) {
        commit('loadingRequest', true);
        accountService.login(username, password, orgId)
            .then(response => {
                commit('accountResponse', response.data);
                commit('computeAllowedPage', response.data.abilities);
                router.push('/');
            })
            .catch(error => {
                console.log('$(TAG) : An error has occured $(error)');
                commit('authError', error);
            });
    },

    logout({ dispatch, commit }) {
        accountService.logout();
        resetCrisp();
        commit('authError', '');
        commit('product/resetProducts', null, {root: true});
        commit('productGroup/resetProductGroups', null, {root: true});
        commit('printer/resetPrinters', null, {root: true});
        commit('icons/resetIcons', null, {root: true});
        commit('images/resetImages', null, {root: true});
        commit('view/resetViews', null, {root: true});
        commit('shift/resetQueryDates', null, {root: true});
        markAppReloading();
        window.location.assign(router.resolve('/login').href);
    },
    getMyData({ dispatch, commit }) {
        accountService.getMyData()
            .then(response => {
                commit('accountResponse', response.data);
                // Indispensable : sans ce commit, firstAllowedPage reste nul
                // apres un rechargement (seul login le calculait), et l'ecran
                // CheckAbilities n'avait alors plus rien vers quoi rediriger.
                commit('computeAllowedPage', response.data.abilities);
            })
            .catch(error => {
                JWTHelper.clearJwt();
                commit('authError', error);
                router.push('/login');
            });
    },
    switchOrg({ dispatch, commit }, orgId) {
        accountService.switchOrg(orgId)
            .then(response => {
                commit('accountResponse', response.data);
                markAppReloading();
                location.reload();
            })
            .catch(error => {
                commit('authError', error);
            });
    }
};

const mutations = {
    loadingRequest: (state, isLoading) => {
        state.loginMessage = '';
        state.isLoadingRequest = isLoading;
    },
    accountResponse: (state, user) => {
        state.isLoggedIn = true;

        user.managedOrganizations = user.managedOrganizations.map(org => {
            org.name = org.name + " - " + org.orgId;
            return org;
        });

        state.user = user;

        localStorage.setItem('orgType', user.organization.orgType);
        localStorage.setItem('orgId', user.orgId);
        state.isSuperUser = user.type === "SUPER_USER";
        state.isLoadingRequest = false;
    },
    authError: (state, errorMessage) => {
        state.isLoadingRequest = false;
        state.user = null;
        state.isLoggedIn = false;
        state.loginMessage = errorMessage;
    },
    computeAllowedPage: (state, abilities) => {
        const userAbilities = abilities || [];
        let abilityPagePermissionManager = new AbilityPagePermissionManager(userAbilities);
        state.abilities = userAbilities;
        state.firstAllowedPage = abilityPagePermissionManager.getFirstAllowedPage();
    }
};

class AbilityPage {
    page = "";
    abilities = [];
    constructor(abilities, page){
        this.page = page;
        this.abilities = [].concat(abilities);
    }
}

class AbilityPagePermissionManager {
    allowedAbilityPages = [
        new AbilityPage("ANALYTICS_DASHBOARD", "/dashboard"),
        new AbilityPage("ANALYTICS_DASHBOARD_GROUPS", "/dashboard"),
        new AbilityPage(["ADMIN_GROUPS", "ADMIN_PRODUCTS"], "/catalog"),
        new AbilityPage("ADMIN_TABLES", "/tables"),
        new AbilityPage("ADMIN_CLIENT_DATA", "/clients"),
        new AbilityPage("ADMIN_PRINTERS", "/printers"),
        new AbilityPage("ANALYTICS_ACCOUNTS", "/analytics/accounts"),
        new AbilityPage("ANALYTICS_SHIFTS", "/analytics/shifts"),
        new AbilityPage("ANALYTICS_ORDERS", "/analytics/orders"),
        new AbilityPage("ANALYTICS_STOCK", "/stock"),
    ];
    firstAllowedPage = "/dashboard";
    abilities = [];

    constructor(abilities){
        this.abilities = abilities;
    }

    getFirstAllowedPage(){
        for (let i = 0; i < this.allowedAbilityPages.length; i++){
            if (this.allowedAbilityPages[i].abilities.every(ability => this.abilities.includes(ability))){
                return this.allowedAbilityPages[i].page;
            }
        }
        return this.firstAllowedPage;
    }
}

export const account = {
    namespaced: true,
    state,
    actions,
    mutations
};
